import {useQuery} from "@tanstack/react-query";

import {fetchRoles, fetchRolesByOwner} from "../../services/network/role-api";
import {FEEDBACK_ENDPOINTS, RECOMMENDATION_ENDPOINTS, ROLE_ENDPOINTS} from "../../services/network/endpoints";
import {RecommendationsApi} from "../../services/network/recommendation-api";
import {FeedbackApi} from "../../services/network/feedback-api";

export function useFetchFeedbacksShort() {
    const {data, error, isLoading} = useQuery({
        queryKey: [FEEDBACK_ENDPOINTS.FETCH_SHORT],
        queryFn: () => FeedbackApi.fetchFeedbacksShort(),
    });

    return {
        fbsShortData: data?.data,
        fbsShortError: error,
        fbsShortIsLoading: isLoading,
    };
}
